import React, { useState } from "react";
import tw, { styled } from "twin.macro";
import Logo from "./Logo";
import { Link } from "gatsby";
import { HiOutlinePlus } from "react-icons/hi";
import { BsArrowLeft } from "react-icons/bs";
import { toggleScroll } from "../../lib/functions";

const Nav = styled.nav(({ open }) => [
  tw`z-excessive-2 bg-dark fixed top-0 left-0 w-full h-full max-h-full overflow-x-hidden overflow-y-auto transition-all duration-500 ease-in-out scale-95 translate-y-4 opacity-0 pointer-events-none`,
  open === true && tw`scale-100 translate-y-0 opacity-100 pointer-events-auto`,
]);

const Top = tw.div`w-full flex items-center justify-center py-8 px-4 relative border-opacity-20 mb-4 after:(content[''] bg-white bg-opacity-20 w-[calc(100% - 6rem)] h-px absolute bottom-0 left-0)`;

const CloseBtn = styled.button`
  ${tw`font-gothic bg-opacity-20 focus:(animate-ping) absolute bottom-0 right-0 flex justify-center items-center gap-2 w-[6rem] text-lg text-white transition-all duration-500 ease-in-out bg-white`}
`;

const Item = styled.li(({ dim }) => [
  tw`flex flex-row leading-none! w-full text-2xl pr-4 relative items-center justify-between font-gothic uppercase tracking-[0.25rem] 
	[a]:(py-4 text-white hover:text-opacity-100! duration-500 ease-in-out)`,
  dim && tw`[a]:text-opacity-40`,
]);

const List = styled.ul(({ open, current, index }) => [
  tw`blur-sm absolute flex flex-col items-stretch justify-center w-full pl-4 duration-500 opacity-0 pointer-events-none`,
  !open && tw`pointer-events-none!`,
  current === index && tw`blur-0 opacity-100 pointer-events-auto`, // current menu
  index < current && tw`translate-x-[-100px]`, // previous menus
  index > current && tw`translate-x-[100px]`, // next menus
]);

const Back = tw.button`text-white py-3  leading-none text-3xl hover:text-primary  duration-500 ease-in-out`;

const Expand = styled.button`
  ${tw`hover:text-primary top-0 bottom-0 h-full px-2 py-4 text-white duration-500 ease-in-out opacity-100`}
`;

const MobileNavigation = ({ open, menu, onClose }) => {
  const [depth, setDepth] = useState(0); // current depth of menu
  const [menus, setMenus] = useState([menu, [], [], [], [], []]);
  const [dim, setDim] = useState(false);

  const handleHover = (children) => {
    const newMenus = menus;
    newMenus[depth + 1] = children;
    setMenus(newMenus);
  };

  const advanceMenu = () => {
    setDepth(depth + 1);
  };

  const backMenu = () => {
    setDepth(depth - 1);
  };

  const dimMenu = () => {
    setDim(true);
  };

  const restoreMenu = () => {
    setDim(false);
  };

  const listItems = (items, back) => {
    return (
      <>
        {back && (
          <li>
            <Back onClick={backMenu} aria-label="Back">
              <BsArrowLeft />
            </Back>
          </li>
        )}
        {items.map((item, i) => {
          return (
            <Item
              key={i}
              target={item.target}
              onMouseEnter={() => handleHover(item.children)}
              dim={dim}
            >
              {item.path &&
                (item.path === "#" ? (
                  <a
                    tw="cursor-pointer px-4"
                    onClick={advanceMenu}
                    onMouseEnter={dimMenu}
                    onMouseLeave={restoreMenu}
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    tw="px-4"
                    to={item.path}
                    onMouseEnter={dimMenu}
                    onMouseLeave={restoreMenu}
                    onClick={() => {
                      toggleScroll();
                      dimMenu();
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              {!!item.children && item.children.length > 0 && (
                <Expand
                  className="advance-button"
                  onClick={advanceMenu}
                  aria-label="expand"
                >
                  <HiOutlinePlus />
                </Expand>
              )}
            </Item>
          );
        })}
      </>
    );
  };

  return (
    <Nav open={open}>
      <Top>
        <Logo
          to="/"
          onClick={() => {
            toggleScroll();
          }}
        />
        <CloseBtn
          onClick={() => {
            onClose();
            setTimeout(() => {
              setDepth(0);
            }, 700);
          }}
        >
          Close
          <HiOutlinePlus tw="rotate-45" />
        </CloseBtn>
      </Top>
      {menus.map((menu, i) => {
        return (
          <List key={i} current={depth} index={i} open={open}>
            {listItems(menu, i > 0)}
          </List>
        );
      })}
    </Nav>
  );
};

export default MobileNavigation;
